import storeHelper from '@/store/helper'
import axios from 'axios'
import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

export class UsersService extends BaseService {
  static get entity () {
    return 'users'
  }

  static async getCurrent (token = null, systemConfig = null) {
    try {
      let response = null
      if (token && systemConfig) {
        response = await axios.post(storeHelper.getUrl('cnps.sur.get-current', systemConfig), {}, {
          headers: {
            Authorization: 'Bearer ' + token
          }
        })
      } else response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.sur.get-current'))
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
